import { useAsync } from '@flowwai-frontend/shared/common-components'

import { ReSendUsernameOTPAPIRequestType } from '../../services/types'

import { useLoginWithUsernameService } from '../services/useLoginWithUsernameService'

const useResendUsernameOTPAPI = () => {
   const loginService = useLoginWithUsernameService()

   const {
      mutateAsync: resendUsernameOTPAPI,
      apiStatus: resendUsernameOTPAPIStatus,
      error: resendUsernameOTPAPIError
   } = useAsync<unknown, Error, ReSendUsernameOTPAPIRequestType>(
      loginService.resendUsernameOTP
   )

   return {
      resendUsernameOTPAPI,
      resendUsernameOTPAPIStatus,
      resendUsernameOTPAPIError
   }
}

export { useResendUsernameOTPAPI }
